import apiClient from '../utils/apiService';

/**
 * 工单列表相关 API
 */
export const workorderApi = {
  // 查询工单列表
  queryList: (params) => apiClient.post('/shipping-order/query', params),
  
  // 获取工单详情
  getDetail: (hblNo) => apiClient.get(`/shipping-order/detail/${hblNo}`),
  
  // 更新工单
  update: (data) => apiClient.put('/shipping-order/update', data),
  
  // 删除工单
  delete: (seq) => apiClient.delete(`/shipping-order/${seq}`),
  
  // 获取状态统计
  getStatusStatistics: () => apiClient.get('/shipping-order/status-statistics'),
  
  // 导出 Excel
  exportExcel: (params) => apiClient.post('/shipping-order/export-excel', params),
  
  // 查询导出结果
  getExportResult: (taskId) => apiClient.get(`/shipping-order/export-excel/result/${taskId}`),

  // 查询订单版本快照
  getVersionSnapshots: (hblNo, params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
    ).toString();
    return apiClient.get(`/shipping-order/version-snapshots/${hblNo}${query ? `?${query}` : ''}`);
  },

  // 查询操作跟踪记录
  getTrackNotes: (hblNo) => apiClient.get(`/shipping-order/track-notes/${hblNo}`),

  // 保存操作跟踪记录
  saveTrackNotes: (data) => apiClient.post('/shipping-order/track-notes/save', data),

  // 获取当前用户工单展示字段配置
  getDisplayFieldsConfig: () => apiClient.get('/shipping-order/display-fields'),

  // 保存当前用户工单展示字段配置
  saveDisplayFieldsConfig: (data) => apiClient.post('/shipping-order/display-fields', data),

  // 重置当前用户工单展示字段配置
  resetDisplayFieldsConfig: () => apiClient.delete('/shipping-order/display-fields'),
};

/**
 * 附件相关 API
 */
export const attachmentApi = {
  // 获取附件列表
  getList: (hblNo) => apiClient.get(`/shipping-order/attachments/${hblNo}`),

  // 批量上传附件，每个文件可对应一个备注
  uploadBatch: (formData) => apiClient.post('/shipping-order/upload-attachments', formData),
  
  // 上传附件
  upload: (formData) => apiClient.post('/shipping-order/upload-attachment', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // 归档邮件附件到附件表
  archiveEmailAttachments: (data) => apiClient.post('/shipping-order/archive-email-attachments', data),
  
  // 获取邮件附件
  getEmailAttachments: (workorderId) => apiClient.get(`/shipping-order/emails-attachments?workorderId=${workorderId}`),

  // 更新附件备注
  updateRemark: (data) => apiClient.put('/shipping-order/attachment/remark', data),
};

/**
 * A/N 邮件相关 API
 */
export const anEmailApi = {
  // 生成 PDF
  generatePdf: (data) => apiClient.post('/shipping-order/generate-pdf', data),
  
  // 发送 A/N 邮件
  send: (params) => apiClient.post('/shipping-order/send-an-email', params),
  
  // 查询发送记录
  queryRecords: (params) => apiClient.post('/an-email-record/query', params),
  
  // 获取 A/N 附件
  getAttachments: (hblNo, emailType) => apiClient.get(`/shipping-order/an-attachments/${hblNo}?emailType=${emailType}`),
  
  // 上传 A/N 附件
  uploadAttachment: (formData) => apiClient.post('/shipping-order/upload-an-attachment', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // 更新 AN/PU 附件备注
  updateRemark: (data) => apiClient.put('/shipping-order/an-attachment/remark', data),
};

/**
 * 邮件详情相关 API
 */
export const emailApi = {
  // 获取邮件详情
  getDetail: (workorderId) => apiClient.get(`/shipping-order/emails-detail?workorderId=${workorderId}`),
};

/**
 * 字段变更记录 API
 */
export const fieldChangeApi = {
  // 查询字段变更记录
  query: (shippingOrderId, fieldName, containNo) => {
    let url = `/shipping-field-change/query?shippingOrderId=${shippingOrderId}&fieldName=${fieldName}`;
    if (containNo) {
      url += `&containNo=${containNo}`;
    }
    return apiClient.get(url);
  },
};

/**
 * 消息通知相关 API
 */
export const notificationApi = {
  // 标记已读
  markRead: (itemId) => apiClient.post(`/message-notifications/${itemId}/read`),
  
  // 标记已处理
  markSolved: (itemId) => apiClient.post(`/message-notifications/${itemId}/solve`),
};

/**
 * 操作员信息 API
 */
export const opInfoApi = {
  // 获取操作员列表
  getList: () => apiClient.get('/prime/auth/op-info-list'),
};

const workorderApis = {
  workorder: workorderApi,
  attachment: attachmentApi,
  anEmail: anEmailApi,
  email: emailApi,
  fieldChange: fieldChangeApi,
  notification: notificationApi,
  opInfo: opInfoApi,
};

export default workorderApis;
